<template>
  <!-- <div class="container"> -->
  <div class="">
    <div class="title">
      <gl-sub-text>表示条件</gl-sub-text>
    </div>
    <div class="option-inline">
      <label class="option-label">併買率</label>
      <md-field class="option-field">
        <md-input
          type="number"
          v-model.number="_concurrent"
          class="option-input"
          min="0"
          required
        ></md-input>
      </md-field>
      <label class="option-label">%以上</label>
    </div>
    <div class="option-inline">
      <label class="option-label">Lift</label>
      <md-field class="option-field">
        <md-input
          type="number"
          v-model.number="_lift"
          class="option-input"
          min="0"
          required
        ></md-input>
      </md-field>
      <label class="option-label">以上</label>
    </div>
  </div>
</template>

<script>
import ErrorReport from '@/mixins/ErrorReport'

export default {
  mixins: [ErrorReport],
  props: {
    concurrent: {
      type: Number,
    },
    lift: {
      type: Number,
    },
  },
  computed: {
    _concurrent: {
      get() {
        return this.concurrent
      },
      set(newVal) {
        this.$emit('update:concurrent', newVal)
      },
    },
    _lift: {
      get() {
        return this.lift
      },
      set(newVal) {
        this.$emit('update:lift', newVal)
      },
    },

    errors() {
      const errors = []

      if (this.concurrent < 0) {
        errors.push('併買率を選択してください')
      }

      if (this.lift < 0) {
        errors.push('Liftを選択してください')
      }

      return errors
    },
  },
}
</script>

<style lang="scss" scoped>
.option-inline {
  display: flex;
}
.option-input {
  width: 60px;
}
.option-field {
  width: 60px;
}
.option-label {
  align-items: center;
  display: flex;
  justify-content: center;
  margin-right: 16px;
  width: 60px;
}
</style>
